import script from "./SyncSourceHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncSourceHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SyncSourceHeader.vue?vue&type=style&index=0&id=3a5db6b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5db6b6"]])

export default __exports__